import * as React from 'react';
import { Transition as HeadlessTransition } from '@headlessui/react';

interface Props {
  show: boolean;
}

export const Transition: React.FC<Props> = ({ show, children }) => {
  return (
    <HeadlessTransition
      show={show}
      enter="transition-opacity duration-75"
      enterFrom="opacity-0"
      enterTo="opacity-100"
      leave="transition duration-200 transform"
      leaveFrom="opacity-100 scale-100"
      leaveTo="opacity-0 scale-95"
    >
      {children}
    </HeadlessTransition>
  );
};
